
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/projects/hyperbench",
      function () {
        return require("private-next-pages/projects/hyperbench/index.page.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/projects/hyperbench"])
      });
    }
  